export default __webpack_public_path__ + "static/media/IMG_2057.9b131019.jpeg";